import React from 'react';
import PropTypes from 'prop-types';
import { TextStyle } from '@lavu-pos/lavu-react-components';
import { Colors } from 'modules/utils';

const propTypes = {
	elementId: PropTypes.string,
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
		PropTypes.string,
	]),
	title: PropTypes.bool,
	className: PropTypes.string,
};

const Label = ({ elementId, children, title, className = '' }) => (
	<TextStyle
		id={elementId}
		fontSize={title ? 17 : 14}
		fontWeight="600"
		color={Colors.PRIMARY_TEXT}
		className={className}
	>
		{children}
	</TextStyle>
);

Label.propTypes = propTypes;

export { Label };
